interface Props {
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
}

const Calendar = ({
  fill = '#1a1818',
  width = '48',
  height = '48',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g>
      <g strokeDasharray="none" strokeMiterlimit="10" strokeWidth="0.529">
        <path
          fill={fill}
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeOpacity="1"
          d="M6.566 6.454a.215.215 0 00-.193-.313H4.727a.216.216 0 00-.218.218c0 .122.096.217.218.217H5.86l-.725.746a.22.22 0 000 .31l.032.027h.001a.22.22 0 00.138.05c.23 0 .443.089.6.252a.85.85 0 010 1.203.887.887 0 01-1.205.001c-.084-.085-.236-.08-.306 0a.217.217 0 00-.064.16.2.2 0 00.064.144c.24.245.561.38.905.38a1.296 1.296 0 001.29-1.29 1.278 1.278 0 00-.869-1.215l.802-.825a.2.2 0 00.043-.065"
          opacity="0.999"
          stopOpacity="1"
        />
        <path
          fill={fill}
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M8.307 6.415a.24.24 0 00-.026-.15.22.22 0 00-.293-.08l-.674.41a.201.201 0 00-.103.12.214.214 0 00.204.28.21.21 0 00.107-.033l.361-.212v2.887c0 .115.098.212.213.212a.21.21 0 00.212-.212z"
          opacity="0.999"
          stopOpacity="1"
        />
        <path
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="1"
          d="M2.589 3.023a.074.074 0 00-.074.074v7.4c0 .04.033.073.074.073h7.522c.041 0 .074-.033.074-.073v-7.4a.074.074 0 00-.074-.074z"
          opacity="0.999"
          stopOpacity="1"
        />
        <path
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="1"
          d="M2.515 5.006h7.67"
          opacity="0.999"
          stopOpacity="1"
        />
        <path
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="1"
          d="M4.604 2.13v1.475"
          opacity="0.999"
          stopOpacity="1"
        />
        <path
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="1"
          d="M8.096 2.13v1.475"
          opacity="0.999"
          stopOpacity="1"
        />
      </g>
    </g>
  </svg>
);

export default Calendar;
